import memoize from "fast-memoize";
import { encrypt, decrypt } from "./crypto";

const ACCESS_TOKEN = "token";
const USER_INFO = "user";
const TOKEN_ENCRYPT_KEY = "EA@ContaUnica!@#";
const memoizeCache = new Map();

/**
 * Armazena o objeto de Sessão no localStorage para permitir o compartilhamento do mesmo entre as abas do browser.
 * Usar o sessionStore implica que a informação adicionada nele só é válida na aba do browser em que foi gerado.
 * Como mecanismo de proteção, criptografamos as informações de Sessão para dificultar que um usuário consiga ter
 * acesso ao mesmo. Entretanto qualquer regra de restrição aplicada no frontend deve ser validada no backend!!!
 */

function setObject(key, value, encryptKey) {
  try {
    memoizeCache.clear();
    return localStorage.setItem(
      key,
      encrypt(encodeURIComponent(JSON.stringify(value)), encryptKey)
    );
  } catch (error) {
    console.error(`Erro ao setar o objeto no sessionStore: ${error}`);
    return undefined;
  }
}

const getObject = memoize(
  (key, encryptKey) => {
    try {
      const value = localStorage.getItem(key);
      if (value)
        return JSON.parse(decodeURIComponent(decrypt(value, encryptKey)));
      return value;
    } catch (error) {
      console.error(`Erro ao buscar o objeto no sessionStore: ${error}`);
      return undefined;
    }
  },
  { cache: { create: () => memoizeCache } }
);

export const Sessao = (key) => {
  var token = getObject(ACCESS_TOKEN, TOKEN_ENCRYPT_KEY);
  if (token) {
    return token[key];
  }
};

export const SessaoUsuario = (key) => {
  var usuario = getObject(USER_INFO, TOKEN_ENCRYPT_KEY);
  if (usuario && key) {
    return usuario[key];
  }
};

export const setSessaoUsuario = (usuarioInfo) => {
  setObject(USER_INFO, usuarioInfo, TOKEN_ENCRYPT_KEY);
};

export const setSessaoToken = (token) => {
  setObject(ACCESS_TOKEN, token, TOKEN_ENCRYPT_KEY);
};

export const limparSessao = () => {
  delete localStorage[ACCESS_TOKEN];
  delete localStorage[USER_INFO];
  delete localStorage["profilePicture"];
  localStorage.clear();
};

/* Caso esteja em desenvolvimetno exporta a função Sessao, para facilitar a depuração */
if (process.env.NODE_ENV === "development") {
  window["GetSessao"] = function () {
    return getObject(ACCESS_TOKEN, TOKEN_ENCRYPT_KEY);
  };

  window["SetSessao"] = function (obj) {
    setObject(ACCESS_TOKEN, obj, TOKEN_ENCRYPT_KEY);
  };

  window["EACache"] = () => memoizeCache;
}
